/**
 * DynamoDB Configuration
 * 
 * Centralized configuration for DynamoDB client
 */

import { DynamoDBClient } from '@aws-sdk/client-dynamodb';
import { DynamoDBDocumentClient } from '@aws-sdk/lib-dynamodb';

// Create DynamoDB client — only used in Lambda environment, not in browser
const client = new DynamoDBClient({
  region: (typeof process !== 'undefined' && process.env?.AWS_REGION) || 'us-east-1',
});

// Create DynamoDB Document client with marshalling options
export const dynamoDbClient = DynamoDBDocumentClient.from(client, {
  marshallOptions: {
    removeUndefinedValues: true,
    convertClassInstanceToMap: true,
  },
  unmarshallOptions: {
    wrapNumbers: false,
  },
});

// Table names from environment variables
export const TABLE_NAMES = {
  SESSIONS: (typeof process !== 'undefined' && process.env?.SESSIONS_TABLE) || 'auth-portal-sessions-dev',
  OAUTH_CLIENTS: (typeof process !== 'undefined' && process.env?.OAUTH_CLIENTS_TABLE) || 'auth-portal-oauth-clients-dev',
  AUTHORIZATION_CODES: (typeof process !== 'undefined' && process.env?.AUTHORIZATION_CODES_TABLE) || 'auth-portal-authorization-codes-dev',
  REVOKED_TOKENS: (typeof process !== 'undefined' && process.env?.REVOKED_TOKENS_TABLE) || 'auth-portal-revoked-tokens-dev',
  RATE_LIMITS: (typeof process !== 'undefined' && process.env?.RATE_LIMITS_TABLE) || 'auth-portal-rate-limits-dev',
};
